import { createSelector } from 'reselect';
import { getInitialState } from './reducer';
export var selectAppCreationFlowDomain = function (state) { return (state && state.appCreationFlow) || getInitialState(); };
export var selectAppCreationFlow = createSelector(selectAppCreationFlowDomain, function (appCreationFlowState) { return appCreationFlowState; });
